<script setup lang="ts">
withDefaults(
    defineProps<{
        id?: string
        type?: string
    }>(),
    {
        type: 'text',
    }
)

const model = defineModel()
</script>

<template>
    <input
        :type="type"
        v-model="model"
        :id="id"
        class="block w-full rounded-md border-0 py-2 text-sm placeholder:text-neutral-400 text-neutral-700 shadow-xs ring-1 ring-inset ring-neutral-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
    />
</template>
